const { objectToUrlParams, getCookie, addSwatchesToProducts } = window.ssUtils;

document.addEventListener('DOMContentLoaded', function() {
    // Get DOM elements and configuration
    const sectionElement = document.getElementById('ss-recommended-products');
    if (!sectionElement) return;

    const tag = sectionElement.getAttribute('data-profile-id');
    if (!tag) return;

    const productId = sectionElement.getAttribute('data-product-id');
    const limit = sectionElement.getAttribute('data-limit');
    const placement = sectionElement.getAttribute('data-placement');

    // Initialize constants and parameters
    const SITE_ID = window.ssSiteId;
    const pageLoadId = window.ssPageLoadId;
    const userId = getCookie('ssUserId') || '';
    const sessionId = getCookie('ssSessionIdNamespace') || '';
    const shopper = getCookie('ssShopperId') || '';
    const cart = getCookie('ssCartProducts') || '';
    const lastViewed = getCookie('ssViewedProducts') || '';

    window.ssRecommendedProductsParams = {
        tags: tag,
        limits: limit || 4,
        ...(productId && { products: productId }),
        ...(shopper && { shopper }),
        ...(cart && { cart }),
        ...(lastViewed && { lastViewed })
    };

    // Initial fetch of recommended products
    fetchProducts();

    /**
     * Fetches recommended products from the API
     */
    async function fetchProducts() {
        try {
            const { ProductCards } = window;
            const productCards = new ProductCards('recommended-products-grid');
            productCards.renderSkeletons(Number(limit) || 4);

            // Build the API URL
            const apiUrl = `https://${SITE_ID}.a.searchspring.io/boost/${SITE_ID}/recommend?${objectToUrlParams(window.ssRecommendedProductsParams)}`;

            // Fetch the data
            const response = await fetch(apiUrl);
            if (!response.ok) {
                throw new Error(`API responded with status: ${response.status}`);
            }

            const data = await response.json();
            if (!data || !data[0] || !data[0].results) {
                throw new Error('Invalid response data');
            }

            window.ssRecommendedProductsData = data;

            // Map the data to the expected format
            const products = data[0].results.map(product => ({
                ...product.mappings.core,
                ...product.attributes
            }));

            // Render products, then add swatches and re-render
            const productsWithSwatches = await addSwatchesToProducts(products);
            productCards.render(productsWithSwatches, true);

            // Send tracking beacon and set up observers
            await sendBeacon({
                tag,
                placement,
                products: data[0].results,
                eventType: 'render'
            });

            setupTrackRecommendationsObserver();
            setupRecommendationClickHandlers();

        } catch (error) {
            console.error('Error fetching recommended products:', error);
        }
    }

    /**
     * Sends analytics beacon for recommendation events
     * @param {Object} params - Beacon parameters
     */
    async function sendBeacon({ tag, placement, products, eventType = 'render' }) {
        if (!products || products.length === 0) return;

        try {
            const context = {
                pageLoadId,
                userId,
                sessionId,
                website: {
                    trackingCode: SITE_ID
                }
            };

            const parentId = uuidv4();
            const parentObject = {
                category: 'searchspring.recommendations.user-interactions',
                context,
                event: {
                    context: {
                        type: 'product-recommendation',
                        tag,
                        placement
                    },
                    profile: {
                        tag,
                        placement,
                        seed: productId ? [productId] : []
                    }
                },
                id: parentId,
                type: `profile.${eventType}`
            };

            const productEvents = products.map(product => ({
                category: 'searchspring.recommendations.user-interactions',
                context,
                event: {
                    context: {
                        type: 'product-recommendation',
                        tag,
                        placement
                    },
                    product: {
                        id: product.id,
                        mappings: product.mappings
                    }
                },
                id: uuidv4(),
                pid: parentId,
                type: `profile.product.${eventType}`
            }));

            const response = await fetch('https://beacon.searchspring.io/beacon', {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'content-type': 'application/json'
                },
                body: JSON.stringify([
                    parentObject,
                    ...productEvents
                ])
            });

            if (!response.ok) {
                throw new Error(`Beacon API responded with status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error sending beacon:', error);
        }
    }

    /**
     * Sets up observer to track when recommendations are viewed
     */
    function setupTrackRecommendationsObserver() {
        const recommendedProductsGrid = document.getElementById('recommended-products-grid');
        if (!recommendedProductsGrid) return;

        // Create an intersection observer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(async entry => {
                if (entry.isIntersecting && window.ssRecommendedProductsData) {
                    const products = window.ssRecommendedProductsData[0]?.results;
                    if (products && products.length > 0) {
                        await sendBeacon({
                            tag,
                            placement,
                            products,
                            eventType: 'impression'
                        });
                    }

                    // Disconnect the observer after the first view
                    observer.disconnect();
                }
            });
        }, {
            threshold: 0.1 // Trigger when at least 10% of the element is visible
        });

        // Start observing
        observer.observe(recommendedProductsGrid);
    }

    /**
     * Sets up click event handlers for recommendation cards
     */
    function setupRecommendationClickHandlers() {
        const recommendationCards = document.querySelectorAll(
            '#recommended-products-grid .product-card a, ' +
            '#recommended-products-grid .product-card button, ' +
            '#recommended-products-grid .product-card label, ' +
            '#recommended-products-grid .product-card input'
        );

        recommendationCards.forEach(card => {
            card.addEventListener('click', handleRecommendationClick);
        });
    }

    /**
     * Handles click events on recommendation cards
     * @param {Event} event - The click event
     */
    async function handleRecommendationClick(event) {
        // Don't track clicks on labels
        if (event.target.tagName.toLowerCase() === 'label') {
            return;
        }

        // Prevent event bubbling for interactive elements
        event.stopPropagation();

        // Find the closest product card
        const productCard = event.target.closest('.product-card');
        if (!productCard || !productCard.dataset.product) return;

        try {
            const product = JSON.parse(productCard.dataset.product);
            await sendBeacon({
                tag,
                placement,
                products: [product],
                eventType: 'click'
            });
        } catch (error) {
            console.error('Error handling recommendation click:', error);
        }
    }
});
